export const mockData = {
  stats: [
    {
      id: 1,
      value: "17M+",
      label: "Yearly Unique Visitors",
      icon: "users"
    },
    {
      id: 2,
      value: "170+",
      label: "Countries Reached",
      icon: "globe"
    },
    {
      id: 3,
      value: "45+",
      label: "Years of Trust",
      icon: "trophy"
    },
    {
      id: 4,
      value: "5.6M",
      label: "Monthly Website Visitors",
      icon: "calendar"
    }
  ],
  benefits: [
    {
      id: 1,
      title: "Massive Exposure",
      description: "Reach millions of engaged readers interested in precious metals, mining, and cryptocurrency markets.",
      icon: "eye"
    },
    {
      id: 2,
      title: "Build Your Authority",
      description: "Establish yourself as a thought leader in the precious metals and crypto space with our trusted platform.",
      icon: "award"
    },
    {
      id: 3,
      title: "Backlinks & Promotion",
      description: "Include links to your website, services, or social media profiles to drive traffic and grow your audience.",
      icon: "link"
    },
    {
      id: 4,
      title: "Engaged Audience",
      description: "Connect with sophisticated investors, traders, and industry professionals actively seeking expert insights.",
      icon: "target"
    }
  ],
  process: [
    {
      id: 1,
      step: "Step 1",
      title: "Submit Your Application",
      description: "Fill out our contributor form with your background, expertise, and writing samples."
    },
    {
      id: 2,
      step: "Step 2",
      title: "Editorial Review",
      description: "Our editorial team reviews your application and portfolio to ensure quality standards."
    },
    {
      id: 3,
      step: "Step 3",
      title: "Get Approved",
      description: "Once approved, you'll receive contributor guidelines and access to our submission portal."
    },
    {
      id: 4,
      step: "Step 4",
      title: "Start Publishing",
      description: "Submit your commentary pieces and watch your reach grow on the world's leading precious metals platform."
    }
  ],
  faqs: [
    {
      id: 1,
      question: "Do you pay contributors?",
      answer: "Kitco News does not offer monetary compensation for contributors. However, you gain significant exposure to our millions of monthly readers, backlinks to your services or website, and the opportunity to establish yourself as an authority in the precious metals and crypto space."
    },
    {
      id: 2,
      question: "What topics can I write about?",
      answer: "We welcome commentary on gold, silver, platinum, palladium, precious metals mining, cryptocurrency, and related financial markets. We're looking for informed analysis, market insights, and expert opinions that provide value to our readers."
    },
    {
      id: 3,
      question: "How often can I contribute?",
      answer: "There's no strict limit on submission frequency. However, we value quality over quantity. We recommend weekly publishing to maintain consistent engagement with our audience while focusing on timely, well-researched pieces that offer unique insights."
    },
    {
      id: 4,
      question: "What are the requirements to become a contributor?",
      answer: "We look for demonstrated expertise in precious metals, mining, or cryptocurrency markets. This can include professional experience, previous publications, market analysis track record, or relevant credentials. Strong writing skills and the ability to provide actionable insights are essential."
    },
    {
      id: 5,
      question: "Can I include links to my website or services?",
      answer: "Yes! Contributors can include bio information with links to their website, advisory services, social media profiles, or other professional platforms. This is one of the key benefits of contributing to Kitco News."
    },
    {
      id: 6,
      question: "How long does the approval process take?",
      answer: "Our editorial team typically reviews applications within 5-7 business days. If approved, you'll receive an email with contributor guidelines and next steps. Due to high volume, we may not be able to respond to all applications."
    },
    {
      id: 7,
      question: "What format should my articles be in?",
      answer: "We accept articles in standard text format (Word docs, Google Docs, or plain text). Typical commentary pieces range from 600-1200 words. Include relevant charts or data if applicable. Our editorial team may suggest edits for clarity or style."
    },
    {
      id: 8,
      question: "Will my content be edited?",
      answer: "Mostly no, unless grammar or clarity adjustments are needed. Our editorial team may make minor edits for grammar, clarity, and AP style compliance to ensure content meets our standards. We'll notify you of any substantial changes. You retain the right to withdraw content if you disagree with significant edits."
    }
  ]
};
